@if (itemsSource) {
  <section>
    <h1 class="header list-header">{{ 'INVOICE.CREDIT_INVOICE' | translate }}</h1>
    <app-multiselect-list-view
      [columnDefinition]="columnDefinitions"
      [contextMenuDefinition]="contextMenuDefinition"
      [itemsSource]="itemsSource"
      [menuDefinition]="menuDefinition"
      [preferencesKey]="'invoice.credit-invoice-list.list'"
      [isToolbarSticky]="true"
      >
    </app-multiselect-list-view>
  </section>
}
